const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@constants
const ADVANCE_END_DATE = 'advanceEndDate';

class LoanPartialAmortizationSuccess extends React.Component {
    constructor(props) {
        super(props);

        const { immPartialAmortization } = props;
        const amortizationType = immPartialAmortization.getIn(['partialAmortizationSimulationData', 'amortizationType']);

        this.isAdvanceEndDate = amortizationType === ADVANCE_END_DATE;
    }

    componentWillMount() {
        const { immLoan, requestPartialAmortization, requestPlanAmortization } = this.props;

        if (this.isAdvanceEndDate) {
            requestPartialAmortization(immLoan);
        } else {
            requestPlanAmortization(immLoan);
        }
    }

    render() {
        const { immLoan, immPartialAmortization } = this.props;
        const successMessage = formatText('loanPartialAmortizationSuccess-successMessage');
        const viewAmortizationPlanButtonLabel = formatText('loanPartialAmortizationSuccess-viewAmortizationPlan');
        const goBackToLoansButtonLabel = formatText('loanPartialAmortizationSuccess-goBackToLoans');
        const linkToLoans = '/myprofile/loans-mortgages';
        const linkToAmortizationPlan = `/myprofile/loans-mortgages/loans/${immLoan.get('loanId')}/repayment-plan`;
        const mainButton = {
            label: goBackToLoansButtonLabel,
            url: linkToLoans
        };
        const secondaryButton = {
            label: viewAmortizationPlanButtonLabel,
            url: linkToAmortizationPlan
        };

        let content, successMessageContent, injectedStrings;

        if (immPartialAmortization.get('isFetchingPlanAmortization') || immPartialAmortization.get('isFetchingPartialAmortization')) {
            content = <LoadingSection />;
        } else {
            const newInstallment = MortgageRequestCurrencyHelp({
                'currency': immPartialAmortization.get('receiptTotal'),
                'symbolCurrency': immLoan.getIn(['balance', 'currency'])
            });
            const alias = immLoan.get('alias');
            const contractNumber = immLoan.get('fullContractNumber');
            const amount = MortgageRequestCurrencyHelp({
                'currency': immPartialAmortization.getIn(['partialAmortizationSimulationData', 'amount'], 0),
                'symbolCurrency': immLoan.getIn(['balance', 'currency'])
            });
            const newDueDate = immPartialAmortization.getIn(['partialAmortizationData', 'dueDate']);

            successMessageContent = 'loanPartialAmortizationSuccess-successMessageDecreaseFee';
            injectedStrings = [alias, contractNumber, amount, newInstallment];

            if (this.isAdvanceEndDate) {
                successMessageContent = 'loanPartialAmortizationSuccess-successMessageAdvanceEndDate';
                injectedStrings = [alias, amount, newDueDate];
            }

            content = <FormattedText value={successMessageContent} injectedStrings={injectedStrings} />;

        }

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardSuccess
                        successMessage={successMessage}
                        mainButton={mainButton}
                        secondaryButton={secondaryButton}
                    >
                        {content}
                    </WizardSuccess>
                </div>
            </div>
        );
    }
}

LoanPartialAmortizationSuccess.propTypes = {
    immPartialAmortization: PropTypes.object.isRequired,
    immLoan: PropTypes.object.isRequired,
    requestPartialAmortization: PropTypes.func.isRequired,
    requestPlanAmortization: PropTypes.func.isRequired
};

module.exports = LoanPartialAmortizationSuccess;
